<template>
  <div>
    <section class="content-header">
      <h1>{{ item && item['name'] }}</h1>
    </section>

    <section class="content">
      <div class="box box-primary">
        <div class="box-body">
      <item-show-errors :entity="'backup'" :is-loading="isLoading"></item-show-errors>


            <table class="table table-striped table-hover">
              <thead>
              <tr>
                <th width="20%">{{$t('field')}}</th>
                <th>{{$t('value')}}</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>{{$t('backup.name')}}</td>
                <td>{{ item['name'] }}</td>
              </tr>
              <tr>
                <td>{{$t('backup.size')}}</td>
                <td>{{ item['size'] }}</td>
              </tr>
              <tr>
                <td>{{$t('backup.status.name')}}</td>
                <td><span v-if="item['status']">{{ item['status']['name'] }}</span></td>
              </tr>
              <tr>
                <td>{{$t('backup.type.name')}}</td>
                <td><span v-if="item['type']">{{ item['type']['name'] }}</span></td>
              </tr>
              <tr>
                <td>{{$t('backup.createdAt')}}</td>
                <td>{{ moment(item['createdAt']).format('DD-MM-YYYY HH:mm') }}</td>
              </tr>
              <tr>
                <td>{{$t('backup.updatedAt')}}</td>
                <td>{{ moment(item['updatedAt']).format('DD-MM-YYYY HH:mm') }}</td>
              </tr>
              <tr>
                <td>{{$t('backup.updatedBy')}}</td>
                <td>{{ item['updatedBy'] }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>


      <item-show-actions :item="item" :entity="'Backup'" :path="'backup'"></item-show-actions>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ItemShowActions from '../layout/ItemShowActions'
import ItemShowErrors from '../layout/errors/ItemShowErrors'

export default {
  components: {ItemShowErrors, ItemShowActions},
  computed: mapGetters({
    isLoading: 'backup/show/isLoading',
    item: 'backup/show/retrieved'
  }),

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      del: 'backup/del/del',
      reset: 'backup/show/reset',
      retrieve: 'backup/show/retrieve'
    }),

    deleteItem (item) {
      if (window.confirm(this.$t('delete_are_you_sure'))) {
        this.del(item).then(() => this.$router.push({ name: 'BackupList' }))
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/backup/Show.vue